module.exports = __webpack_public_path__ + "static/media/2.654e5fa6.png";